import { DipResponse } from "interfaces";
import { DipSlice } from "./types";

export const initialState: DipSlice = {
	opened: false,
	fromHud: false,
	hudTimerExpirationDate: undefined,
	activeTrigger: undefined,
	triggerCached: undefined,
	currentDip: undefined,
	pendingData: false,
	sessionStartDipStatus: "loading",
	data: {} as DipResponse,
	queueTriggers: [],
	dipType: undefined,
	claimRewardProcess: {
		loading: false,
		error: false,
		claiming: false
	},
	availableTriggers: [],
	mode: "default",
	debug: {
		segments: [],
		data: undefined,
		userSegment: undefined
	},
	pricePoint: undefined
};
